import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "@/styles/public.css";
import "@/styles/reference.css";
import "@/styles/premium.css";
import TopBar from "@/components/site/TopBar";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import { StickyBar, ExitIntent } from "@/components/site/conversion";

export default function SiteLayout({ children }) {
  const ref = useRef(null);
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) requestAnimationFrame(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      let disclosure = target?.closest("details");
      while (disclosure) { disclosure.open = true; disclosure = disclosure.parentElement?.closest("details"); }
      target?.scrollIntoView();
    });
    else window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  useEffect(() => {
    if (window.__PRERENDER__ || !window.matchMedia("(prefers-reduced-motion: no-preference) and (min-width: 960px)").matches) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add("is-revealed"); observer.unobserve(entry.target); }
    }), { threshold: 0.12 });
    ref.current?.querySelectorAll("[data-reveal]").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [children, pathname]);
  return (
    <div className="atlas-public" ref={ref} data-testid="public-layout">
      <a className="at-skip" href="#main-content" data-testid="skip-to-content">Skip to content</a>
      <Nav />
      <main id="main-content">{children}</main>
      <TopBar />
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
      <StickyBar />
      <ExitIntent />
    </div>
  );
}
